import { assetFor } from '@runtime/core/theme/assets'
import type {
  ProfileBoardCell,
  ProfileMove,
} from '@runtime/features/profile/model/profileTypes'
import styles from '@runtime/features/profile/history/review/HistoryReviewBoard.module.scss'

type HistoryReviewBoardProps = {
  boardToShow: ProfileBoardCell[][]
  grid: number
  lastMove: ProfileMove | null
  mode: string
  tiles?: string[]
}

export default function HistoryReviewBoard({
  boardToShow,
  grid,
  lastMove,
  mode,
  tiles,
}: HistoryReviewBoardProps) {
  return (
    <div
      className={styles.reviewBoard}
      style={{
        gridTemplateColumns: `repeat(${grid}, 1fr)`,
      }}
    >
      {boardToShow.map((row, rowIndex) =>
        row.map((cell, columnIndex) => {
          const isLast =
            !!lastMove && lastMove.r === rowIndex && lastMove.c === columnIndex

          return (
            <div
              key={`${rowIndex}-${columnIndex}`}
              className={[
                styles.reviewCell,
                isLast ? styles.reviewCellLast : '',
              ]
                .filter(Boolean)
                .join(' ')}
            >
              {cell?.key ? (
                <img
                  src={
                    mode.startsWith('puzzlePoster') && Array.isArray(tiles)
                      ? tiles[Number(cell.key)] || assetFor(cell.key)
                      : assetFor(cell.key)
                  }
                  alt=""
                  style={{
                    transform: `rotate(${(cell.rot || 0) * 90}deg)`,
                  }}
                />
              ) : null}
            </div>
          )
        }),
      )}
    </div>
  )
}
